<template>
  <page-template>
    <board :is-fold="isFold" :http-options="httpOptions" :config="config" />
  </page-template>
</template>
      <!-- :insert-row-function="() => insertRow('createEmptyWine')"
      :delete-row-function="(rows) => deleteRow('deleteWines', rows)" -->

<script>
import Vue from "vue";

import config from "./Config";
import axios from "axios";
import DetailsEditor from "./detail-row/WineLimitEditor";
import CommonBoardItems from "../../CommonBoardItems";

export default {
  name: "BoardLimits",
  mixins: [CommonBoardItems],
  data() {
    return {
      config
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/spa/components/board/wine/limits/BoardLimits.vue